import {Container, Typography} from "@mui/material";
import React from "react";
import {api} from "../../services/apiService";

import ProductOrOptionForm from "../../components/ProductOrOptionForm";


export default function OptionAdd() {
    const handleSubmit = (formData) => {
        return api.post("/options/add", formData)
            .then(response => {
                console.log("Option added:", response.data);
            })
            .catch(error => {
                console.error("Error adding Option:", error);
            });
    };

    return (
        <Container>
            <Typography variant="h1" gutterBottom>Ajouter une option</Typography>

            <ProductOrOptionForm onSubmit={handleSubmit} showDurationField={false}/>
        </Container>
    );
}
